export const removeEmptyFields = (obj) => {
    if (Array.isArray(obj)) {
        return obj
            .map(item => removeEmptyFields(item))
            .filter(item => Object.keys(item).length > 0);
    }

    return Object.entries(obj)
        .filter(([_, v]) => v != null && (typeof v !== 'object' || (Array.isArray(v) ? v.length > 0 : Object.keys(v).length > 0)))
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
};
